import {
  FILTER_ON_ITEMS_CHECKED,
  ONLY_SHOW_ITEMS_CHECKED,
  ONLY_SHOW_ITEMS_WITH_CHECKED,
  FILTER_ON_IMPC_CHECKED,
  FILTER_ON_DESPATCH_CHECKED,
  MANUAL_ENTRY,
  SPACE_SEPERATED_SUFFIXES,
} from "./types/ItemCriteriaTypes";

export function filterOnItemCheckedActionCreator(
  nodesItemCriteria,
  checkedItemCriteria
) {
  return {
    type: FILTER_ON_ITEMS_CHECKED,
    nodesItemCriteria,
    checkedItemCriteria,
  };
}

export function onlyShowItemCheckedActionCreator(
  nodesItemCriteria,
  checkedItemCriteria
) {
  return {
    type: ONLY_SHOW_ITEMS_CHECKED,
    nodesItemCriteria,
    checkedItemCriteria,
  };
}

export function onlyShowItemWithCheckedActionCreator(
  nodesItemCriteria,
  checkedItemCriteria
) {
  return {
    type: ONLY_SHOW_ITEMS_WITH_CHECKED,
    nodesItemCriteria,
    checkedItemCriteria,
  };
}

export function filterOnIMPCCheckedActionCreator(status) {
  return {
    type: FILTER_ON_IMPC_CHECKED,
    status,
  };
}

export function filterOnDespatchCheckedActionCreator(status) {
  return {
    type: FILTER_ON_DESPATCH_CHECKED,
    status,
  };
}

export function filterOnManualEntryActionCreator(seperatedString) {
  return {
    type: MANUAL_ENTRY,
    seperatedString,
  };
}

export function spaceSeparatedSuffixesActionCreator(suffixText) {
  return {
    type: SPACE_SEPERATED_SUFFIXES,
    suffixText,
  };
}
